import { Outlet } from "react-router-dom";
import useSiteEntityManager from "@/utils/hooks/useSiteEntityManager";
import { AppSuspense } from "../AppSuspense";
import StoreFullScreenLoading from "./StoreFullScreenLoading";

/**
 * Minimal full-screen layout for product pages.
 *
 * Calls `useSiteEntityManager()` so entity data is loaded (same as
 * StoreSinglePageOutlet), but renders NO header/footer chrome.
 * This allows custom pages (published or preview) to take over the
 * entire viewport.
 */
const FullScreenProductOutlet = () => {
  useSiteEntityManager();
  return (
    <div style={{ minHeight: "100svh", overflowX: "clip" }}>
      <AppSuspense fallback={<StoreFullScreenLoading storeHeader={false} />}>
        <Outlet />
      </AppSuspense>
    </div>
  );
};

export default FullScreenProductOutlet;
